module.exports = __webpack_public_path__ + "static/media/tick-circle.0dca2214.svg";